import { AutoResizeDirective } from "./../../helpers/autoSize";
import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { FormsModule } from "@angular/forms";
import {
  Dialog,
  SharedModule,
  NotificationService,
  ModalService,
  DataService,
  Asset,
} from "@bb-vendure/admin-ui/core";
import { FormatStatusPipe } from "../../helpers/formatStatus";
import {
  UpdateQuestionPostDocument,
  UpdateQuestionPostMutation,
  FetchQuestionPostQuery,
  FetchQuestionPostDetailQuery,
  FetchQuestionPostDetailDocument,
  ReplyQaDocument,
  DeleteQuestionDocument,
  QuestionPostStatus,
  ChangeQuestionStatusDocument,
} from "src/generated-gql/graphql";
import { take } from "rxjs";
import { CommentComponent } from "./message/message.component";
import { ImageSelectorComponent } from "../../../images-selector/image-selector.component";

interface SelectedAssets {
  assets?: any[];
  featuredAsset?: any;
}
@Component({
  selector: "reply-modal",
  templateUrl: "./question-post-dialog.component.html",
  styleUrl: "./question-post-dialog.component.scss",
  standalone: true,
  imports: [
    SharedModule,
    FormatStatusPipe,
    FormsModule,
    AutoResizeDirective,
    CommentComponent,
    ImageSelectorComponent,
  ],
})
export class QuestionPostDialog implements Dialog, OnInit {
  constructor(
    private dataService: DataService,
    private notificationService: NotificationService,
    private modalService: ModalService
  ) {}

  resolveWith: (result?: any) => void;
  ngOnInit(): void {
    this.dataService
      .query(FetchQuestionPostDetailDocument, {
        id: this.questionId,
      })
      .single$.pipe(take(1))
      .subscribe((res) => {
        if (res.questionPost) {
          this.question = res.questionPost;
          this.comments = res.questionPost.comments
            ? [...res.questionPost.comments]
            : [];

          this.comments = this.comments.sort((a, b) => a.id - b.id);

          this.isPublic = !this.question.secret;
          if (this.question.files && this.question.files.length > 0) {
            this.assetChanges.assets = this.question.files;
            this.assetChanges.featuredAsset = this.question.files[0];
          }
        }
      });
  }

  isPublic: boolean = false;
  reply: string = "";
  assetChanges: SelectedAssets = {};

  @Input()
  questionId: string;

  @Input() refresh: () => void;

  comments: any[] = [];

  question: NonNullable<FetchQuestionPostDetailQuery["questionPost"]>;

  cancel() {
    this.resolveWith(null);
  }

  setSecret(e: boolean) {
    this.dataService
      .mutate(UpdateQuestionPostDocument, {
        input: {
          id: this.question.id,
          secret: !e,
        },
      })
      .pipe(take(1))
      .subscribe(({ updateQuestionPost }) => {
        if (updateQuestionPost.id) {
          this.refresh();
        }
      });
  }

  comment() {
    if (this.reply === "") {
      this.notificationService.error("Reply cannot be empty");
      return;
    }

    this.dataService
      .mutate(ReplyQaDocument, {
        input: {
          postId: this.questionId,
          detail: this.reply,
        },
      })
      .pipe(take(1))
      .subscribe((res) => {
        if (res.commentQuestionPost) {
          this.refreshQuestion();
          this.refresh();
        }
      });
  }

  delete() {
    this.modalService
      .dialog({
        title: "Delete",
        body: "Are you sure you want to delete this question?",
        buttons: [
          { label: "Yes, Delete", returnValue: "yes", type: "danger" },
          { label: "No", returnValue: "no", type: "secondary" },
        ],
      })
      .subscribe((result) => {
        if (result === "yes") {
          this.dataService
            .mutate(DeleteQuestionDocument, {
              id: this.questionId,
            })
            .pipe(take(1))
            .subscribe((res) => {
              if (res.deleteQuestionPost) {
                this.refresh();
                this.resolveWith(null);
              }
            });
        }
      });
  }

  changeStatus() {
    this.dataService
      .mutate(ChangeQuestionStatusDocument, {
        id: this.questionId,
        status:
          this.question.status === QuestionPostStatus.Resolved
            ? QuestionPostStatus.Open
            : QuestionPostStatus.Resolved,
      })
      .pipe(take(1))
      .subscribe((res) => {
        if (res.changeQuestionPostStatus) {
          this.notificationService.success("Update question post successfully");
          this.refreshQuestion();
          this.refresh();
        }
      });
  }

  pushWeChat() {
    const url = `https://aichat.namilmarket.com/index.php/main/pushqa?id=${this.questionId}&from=kor&key=nanyi2018123!!!`;
    fetch(url)
        .then(response => {
          if (response.status === 200) {
            this.notificationService.success('Call api successfully');
          } else {
            this.notificationService.error(`Failed to call api. Status: ${response.status}`);
          }
        })
        .catch(error => {
          this.notificationService.error(`Error calling api: ${error.message}`);
        });
  }

  refreshQuestion() {
    this.dataService
      .query(FetchQuestionPostDetailDocument, {
        id: this.questionId,
      })
      .single$.pipe(take(1))
      .subscribe((res) => {
        if (res.questionPost) {
          this.question = res.questionPost;
          this.comments = res.questionPost.comments
            ? [...res.questionPost.comments]
            : [];

          this.comments = this.comments.sort((a, b) => a.id - b.id);
          this.isPublic = !this.question.secret;
          this.reply = "";
        }
      });
  }

  changeStatusBtnText() {
    if (this.question.status === QuestionPostStatus.Resolved) {
      return "qa.re-open";
    }

    return "qa.Resolved";
  }

  sortedCommets() {
    const sortedComments = this.question.comments;

    if (!sortedComments) {
      return [];
    }

    sortedComments.sort((a, b) => a.createdAt - b.createdAt);

    return sortedComments;
  }
}
